import React from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { ScreenProps } from '../../types/ptp';
import { PrimaryButton } from '../ui/PrimaryButton';
const SAFETY_CHECKS = ['Crane inspection completed', 'Rigging inspection completed', 'Weather conditions acceptable', 'Communication signals confirmed', 'Work area barricaded'];
export function EquipmentSafetyScreen({
  data,
  updateData,
  onNext
}: ScreenProps) {
  const handleToggleCheck = (check: string) => {
    const current = data.safetyChecks;
    const updated = current.includes(check) ? current.filter(item => item !== check) : [...current, check];
    updateData({
      safetyChecks: updated
    });
  };
  return <div className="flex flex-col h-full" data-id="element-197">
      <div className="mb-6" data-id="element-198">
        <h2 className="text-2xl font-bold text-white mb-2" data-id="element-199">
          Equipment & Safety Checks
        </h2>
        <p className="text-slate-400" data-id="element-200">
          Verify required equipment and pre-work conditions.
        </p>
      </div>

      <div className="flex-1 overflow-y-auto pb-6 -mx-2 px-2 space-y-8" data-id="element-201">
        <section data-id="element-202">
          <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-3" data-id="element-203">
            Equipment Used
          </h3>
          <div className="flex flex-wrap gap-2" data-id="element-204">
            {data.equipment.map((item, i) => <div key={i} className="bg-slate-800 border border-slate-700 text-slate-300 px-3 py-1.5 rounded-md text-sm font-medium" data-id="element-205">
                {item}
              </div>)}
          </div>
        </section>

        <section data-id="element-206">
          <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-3" data-id="element-207">
            Pre-Work Safety Checks
          </h3>
          <div className="space-y-3" data-id="element-208">
            {SAFETY_CHECKS.map((check, i) => {
            const isChecked = data.safetyChecks.includes(check);
            return <motion.button key={i} whileTap={{
              scale: 0.98
            }} onClick={() => handleToggleCheck(check)} className={`w-full text-left p-4 rounded-xl border-2 flex items-center gap-4 transition-colors ${isChecked ? 'bg-slate-900 border-green-500/50' : 'bg-slate-900 border-slate-800 hover:border-slate-700'}`} data-id="element-209">
                  <div className={`w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0 transition-colors ${isChecked ? 'bg-green-500 text-white' : 'bg-slate-800 border border-slate-600'}`} data-id="element-210">
                    {isChecked && <CheckIcon className="w-4 h-4" data-id="element-211" />}
                  </div>
                  <span className={`font-medium text-sm ${isChecked ? 'text-white' : 'text-slate-300'}`} data-id="element-212">
                    {check}
                  </span>
                </motion.button>;
          })}
          </div>
        </section>
      </div>

      <div className="pt-4 bg-slate-950" data-id="element-213">
        <PrimaryButton onClick={onNext} data-id="element-214">Generate PTP</PrimaryButton>
      </div>
    </div>;
}